<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Client Dashboard</h3>

            <div class="search_bar mb-2" v-if="$store.state.user_obj &&
                $store.state.user_obj.user_name != 'lna_client'
                ">
                <b-row v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Order Master Upload',
                true
            )
                ">
                    <b-col cols="4" class="pr-1">
                        <b-form-file v-model="upload_file" placeholder="Choose a file..." size="sm"></b-form-file>
                    </b-col>

                    <b-col class="text-left p-0">
                        <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile">Upload</b-button>
                    </b-col>
                </b-row>
            </div>

            <div class="search_bar mb-2">
                <b-card>
                    <b-row class="mb-1" v-show="true">
                        <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.status_selected"
                                :options="status_options" />
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.payment_status_selected"
                                :options="payment_status_options" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
                            <!-- <strong>Order Date </strong> -->
                            <b-form-input id="input-small" size="sm" type="text" placeholder="Order#" value="Order Date"
                                :disabled="true"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.start_at"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.end_at"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.scheduled_delivery_date"
                                :options="scheduled_delivery_date_options" />
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
                            v-if="search_criteria.scheduled_delivery_date == 'scheduled_date_yes'">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.scheduled_delivery_date_start_at"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
                            v-if="search_criteria.scheduled_delivery_date == 'scheduled_date_yes'">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.scheduled_delivery_date_end_at"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="true || $store.state.user_obj.client_id == '77'">
                        <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.collection_date"
                                :options="collection_date_options" />
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
                            v-if="search_criteria.collection_date == 'collection_date_yes'">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.collection_date_start_at"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
                            v-if="search_criteria.collection_date == 'collection_date_yes'">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.collection_date_end_at"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="true || $store.state.user_obj.client_id == '77'">
                        <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.successful_date"
                                :options="successful_date_options" />
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
                            v-if="search_criteria.successful_date == 'successful_date_yes'">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.successful_date_start_at"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
                            v-if="search_criteria.successful_date == 'successful_date_yes'">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.successful_date_end_at"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col cols="12" sm="12" md="4" class="pl-1 pr-1">
                            <b-form-input id="input-small" size="sm" type="text" placeholder="Order#"
                                v-model="search_criteria.keyword" @keyup.enter="onSearch"></b-form-input>
                        </b-col>

                        <b-col class="text-left p-0">
                            <b-button class="btn-action" size="sm" variant="info" @click="onSearch" v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Search',
                true
            )
                ">
                                <font-awesome-icon class="mr-1" icon="search" />Search
                            </b-button>

                            <b-button class="btn-action" size="sm" variant="info" @click="exportXLS_All">Export (All
                                Data)
                                XLS</b-button>
                            <b-button class="btn-action" size="sm" variant="info" @click="exportXLS_Inventory">Export
                                Inventory XLS</b-button>
                        </b-col>
                    </b-row>
                    <b-row v-if="$store.state.user_obj.client_id == '69'">
                        <b-col cols="12" sm="12" md="4" class="pl-0 pr-1 mt-1">
                            <b-button class="btn-action" size="sm" variant="info" @click="exportAMLo2oActive">Export
                                Active
                                Stock</b-button>

                            <b-button class="btn-action" size="sm" variant="info" @click="exportAMLo2oStockout">Export
                                Total
                                Stock Out</b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" sm="12" md="4" class="pl-1 pr-1">
                            <b-button class="btn-action" size="sm" variant="info" :to="{
                name: 'order_master_add',
            }">
                                Add Order
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </div>

            <div class="search_bar mb-1">
                <b-row class="">
                    <b-col class="pr-1">
                        <b-button class="btn-action" size="sm" variant="info" @click="bulkDownloadWaybill">Download
                            Waybill</b-button>
                    </b-col>
                </b-row>
            </div>

            <strong># of Records: {{ total_rows }}</strong>

            <b-row class="mb-1">
                <b-col cols="1" class="pr-0">
                    <b-form-select size="sm" v-model="sel_table_limit" :options="[50, 100, 200, 500]"
                        @change="getOrderMaster()" />
                </b-col>
                <b-col class="pl-0 pr-1">
                    <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
                        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
                </b-col>
            </b-row>

            <b-table responsive small outlined striped hover :items="items" :fields="fields" :tbody-tr-class="rowClass">
                <template v-slot:head(chk_box)="data">
                    <b-form-checkbox size="sm" plain id="chkbox_all" value="all"
                        v-model="check_all_rows"></b-form-checkbox>
                </template>

                <template v-slot:cell(chk_box)="data">
                    <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
                        v-model="data.item.is_checked"></b-form-checkbox>
                </template>

                <template v-slot:cell(order_date)="data">
                    {{ displayDate(data.item.order_date) }}
                </template>

                <template v-slot:cell(order_number)="data">
                    <router-link :to="{
                name: 'tracking_detail',
                params: { id: data.item.tracking_id },
            }">
                        {{ data.item.order_number }}
                    </router-link>
                </template>

                <template v-slot:cell(related_orders)="data">
                    <span v-if="data.item.related_orders.length == 0" class="dot_white"></span>

                    <span v-if="data.item.related_orders.length > 0" class="dot_green"></span>
                </template>

                <template v-slot:cell(payment_status)="data">
                    {{ data.item.payment_status || "-" }}
                </template>

                <template v-slot:cell(order_import_status)="data">
                    <div>
                        <span class="span-status">{{ data.item.order_import_status }}</span>

                        <span v-if="data.item.order_import_status == 'cancel'" class="dot_red"></span>
                        <span v-if="data.item.order_import_status == 'hold'" class="dot_red"></span>
                        <span v-if="data.item.order_import_status == 'pending'" class="dot_yellow"></span>
                        <span v-if="data.item.order_import_status == 'received'" class="dot_green"></span>
                    </div>
                </template>

                <template v-slot:cell(stock_status)="data">
                    <div>
                        <span class="span-status">{{ data.item.stock_status }}</span>

                        <span v-if="data.item.stock_status == '-'" class="dot_white"></span>
                        <span v-if="data.item.stock_status == 'pending'" class="dot_red"></span>
                        <span v-if="data.item.stock_status == 'available'" class="dot_yellow"></span>
                        <span v-if="data.item.stock_status == 'committed'" class="dot_green"></span>
                    </div>
                </template>

                <template v-slot:cell(fulfilment_status)="data">
                    <div>
                        <span class="span-status">{{ data.item.fulfilment_status }}</span>

                        <span v-if="data.item.fulfilment_status == '-'" class="dot_white"></span>
                        <span v-if="data.item.fulfilment_status == 'pending'" class="dot_yellow"></span>
                        <span v-if="data.item.fulfilment_status == 'completed'" class="dot_green"></span>
                        <span v-if="data.item.fulfilment_status == 'fulfiled'" class="dot_green"></span>
                        <span v-if="data.item.fulfilment_status == 'start_picking'" class="dot_yellow"></span>
                        <span v-if="data.item.fulfilment_status == 'cannot_find_inventory'" class="dot_red"></span>
                        <span v-if="data.item.fulfilment_status == 'other_issues'" class="dot_red"></span>
                    </div>
                </template>

                <!-- <template v-slot:cell(delivery_status)="data">
            <div>
              
              <span v-if="data.item.delivery_status == '-'" class="dot_white"></span>
              <span v-if="data.item.delivery_status == 'pending'" class="dot_yellow"></span>
              <span v-if="data.item.delivery_status == 'completed'" class="dot_green"></span>
              <span v-if="data.item.delivery_status == 'fulfiled'" class="dot_green"></span>
  
            </div>
          </template> -->

                <template v-slot:cell(action)="data">
                    <b-button class="btn-action" size="sm" variant="info">Download Waybill</b-button>
                </template>
            </b-table>

            <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
                @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";

const fields = [
    {
        key: "chk_box",
        label: "",
    },
    // {
    //   key: "channel",
    //   label: "Channel",
    // },
    {
        key: "order_date",
        label: "Order Date",
    },
    {
        key: "order_number",
        label: "Order#",
    },
    {
        key: "payment_status",
        label: "Payment Status",
        class: "txt_camelcase"
    },
    {
        key: "scheduled_delivery_date",
        label: "Scheduled Delivery Date",
        class: "center_align",
    },
    // {
    //   key: "related_orders",
    //   label: "Grouped",
    //   class: "txt_camelcase center_align",
    // },
    // {
    //   key: "payment_status",
    //   label: "Payment",
    //   class: "txt_camelcase center_align",
    // },
    // {
    //   key: "order_import_status",
    //   label: "Order Status",
    //   class: "txt_camelcase center_align container-status",
    // },
    // {
    //   key: "stock_status",
    //   label: "Stock Status",
    //   class: "txt_camelcase center_align container-status",
    // },
    // {
    //   key: "fulfilment_status",
    //   label: "Fulfilment Status",
    //   class: "txt_camelcase center_align container-status",
    // },
    {
        key: "delivery_status",
        label: "Delivery Status",
        class: "txt_camelcase center_align",
    },
    {
        key: "collection_store",
        label: "Collection Store",
        class: "txt_camelcase center_align",
    },
    {
        key: "collection_date",
        label: "Collection Date",
        class: "txt_camelcase center_align",
    },
    {
        key: "waybill_print_at",
        label: "Last Print Date",
        class: "txt_camelcase center_align",
    },
    {
        key: "successful_date",
        label: "Successful Date",
        class: "txt_camelcase center_align",
    },

    {
        key: "action",
        label: "Action",
    },
];

const collection_fields = [
    {
        key: "chk_box",
        label: "",
    },
    {
        key: "channel",
        label: "Channel",
    },
    {
        key: "order_date",
        label: "Order Date",
    },
    {
        key: "order_number",
        label: "Order#",
    },
    {
        key: "scheduled_delivery_date",
        label: "Delivery Date",
        class: "center_align",
    },
    {
        key: "collection_date",
        label: "Collection Date",
        class: "center_align",
    },
    // {
    //   key: "related_orders",
    //   label: "Grouped",
    //   class: "txt_camelcase center_align",
    // },
    {
        key: "payment_status",
        label: "Payment",
        class: "txt_camelcase center_align",
    },
    {
        key: "order_import_status",
        label: "Order Status",
        class: "txt_camelcase center_align container-status",
    },
    {
        key: "stock_status",
        label: "Stock Status",
        class: "txt_camelcase center_align container-status",
    },
    {
        key: "fulfilment_status",
        label: "Fulfilment Status",
        class: "txt_camelcase center_align container-status",
    },
    {
        key: "delivery_status",
        label: "Delivery Status",
        class: "txt_camelcase center_align",
    },
    {
        key: "action",
        label: "Action",
    },
];

export default {
    name: "OrderMaster",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        barcode: VueBarcode,
    },
    data() {
        return {
            sel_table_limit: 100,
            courier_options: [],
            export_date: {
                start_at: moment().subtract(7, "d").format("YYYY-MM-DD"),
                end_at: moment().format("YYYY-MM-DD"),
            },
            upload_file: [],
            upload_file_edit: [],
            loader_full: false,
            loader: false,
            items: [],
            fields: fields,
            currentPage: 1,
            table_offset: 0,
            total_rows: 0,
            updating_item: false,
            export_criteria: {
                courier_selected: null,
                channel_selected: null,
            },
            search_criteria: {
                keyword: "",
                channel_selected: null,
                client_selected: null,
                order_alert_selected: null,
                start_at: moment().subtract(6, "months").format("YYYY-MM-DD"),
                end_at: moment().format("YYYY-MM-DD"),
                scheduled_delivery_date_start_at: moment()
                    .subtract(6, "months")
                    .format("YYYY-MM-DD"),
                scheduled_delivery_date_end_at: moment()
                    .add(1, "months")
                    .format("YYYY-MM-DD"),
                collection_date_start_at: moment()
                    .subtract(6, "months")
                    .format("YYYY-MM-DD"),
                collection_date_end_at: moment()
                    .add(1, "months")
                    .format("YYYY-MM-DD"),
                successful_date_start_at: moment()
                    .subtract(6, "months")
                    .format("YYYY-MM-DD"),
                successful_date_end_at: moment()
                    .add(1, "months")
                    .format("YYYY-MM-DD"),
                order_status_selected: null,
                stock_status_selected: null,
                fulfilment_status_selected: null,
                scheduled_delivery_date: null,
                collection_date: null,
                successful_date: null,
                status_selected: null,
                payment_status_selected: null
            },
            showAlert_success: false,
            alert_success_message: "",

            showAlert_error: false,
            alert_error_message: "",

            channel_options: [
                {
                    value: null,
                    text: "All Channel",
                },
            ],

            payment_status_options: [
                {
                    value: null,
                    text: "All Payment Status",
                },
                {
                    value: 'Fully Paid',
                    text: "Fully Paid",
                },
                {
                    value: 'Pending',
                    text: "Pending",
                },
            ],

            status_options: [
                {
                    value: null,
                    text: "All Tracking Status",
                },
                {
                    value: "Pending",
                    text: "Pending",
                },
                {
                    value: "In_Transit",
                    text: "In_Transit",
                },
                {
                    value: "Successful",
                    text: "Successful",
                },
                {
                    value: "Cancelled",
                    text: "Cancelled",
                },
                {
                    value: "Shipped_Ext",
                    text: "Shipped_Ext",
                },
                {
                    value: "Returned_to_Warehouse",
                    text: "Returned_to_Warehouse",
                },
                {
                    value: "Rescheduled",
                    text: "Rescheduled",
                },
                {
                    value: "Unsuccessful_Delay",
                    text: "Unsuccessful_Delay",
                },
                {
                    value: "Unsuccessful_Other",
                    text: "Unsuccessful_Other",
                },
                {
                    value: "Unsuccessful_Reject",
                    text: "Unsuccessful_Reject",
                },
                {
                    value: "Hold",
                    text: "Hold",
                },
                {
                    value: "Unsuccessful_Unreach",
                    text: "Unsuccessful_Unreach",
                },
                {
                    value: "Ready_for_Fulfilment",
                    text: "Ready_for_Fulfilment",
                },
                {
                    value: "Ready_for_Shipment",
                    text: "Ready_for_Shipment",
                },
                {
                    value: "Ready_for_Redemption",
                    text: "Ready_for_Redemption",
                },
                {
                    value: "Redemption_Reserved",
                    text: "Redemption_Reserved",
                },
                {
                    value: "Redemption_Checked-In ",
                    text: "Redemption_Checked-In ",
                },
                {
                    value: "Redemption_Expired",
                    text: "Redemption_Expired",
                },
                {
                    value: "Redemption_Checked-Out",
                    text: "Redemption_Checked-Out",
                },
                {
                    value: "Redemption_Collected",
                    text: "Redemption_Collected",
                },
                {
                    value: "Redemption_Autovoided",
                    text: "Redemption_Autovoided",
                },
                {
                    value: "Redemption_Returned",
                    text: "Redemption_Returned",
                },
                {
                    value: "Redemption_Abnormal",
                    text: "Redemption_Abnormal",
                },
                {
                    value: "Redemption_CancelledCustomer",
                    text: "Redemption_CancelledCustomer",
                },
                {
                    value: "Redemption_Cancelled",
                    text: "Redemption_Cancelled",
                },
            ],

            client_options: [
                {
                    value: null,
                    text: "All Clients",
                },
            ],

            order_status_options: [
                {
                    value: null,
                    text: "All Order Status",
                },
                {
                    value: "cancel",
                    text: "Cancel",
                },
                {
                    value: "received",
                    text: "Received",
                },
                {
                    value: "pending",
                    text: "Pending",
                },
                {
                    value: "hold",
                    text: "Hold",
                },
            ],
            stock_status_options: [
                {
                    value: null,
                    text: "All Stock Status",
                },
                {
                    value: "-",
                    text: "-",
                },
                {
                    value: "pending",
                    text: "Pending",
                },
                {
                    value: "available",
                    text: "Available",
                },
                {
                    value: "committed",
                    text: "Committed",
                },
            ],

            fulfilment_status_options: [
                {
                    value: null,
                    text: "All Fulfilment Status",
                },
                {
                    value: "fulfiled",
                    text: "Fulfilled",
                },
                {
                    value: "pending",
                    text: "Pending",
                },

                {
                    value: "start_picking",
                    text: "Start Picking",
                },
                {
                    value: "cannot_find_inventory",
                    text: "Cannot Find Inventory",
                },
                {
                    value: "other_issues",
                    text: "Other Issues",
                },
            ],

            check_all_rows: false,
            outstanding_order_cnts: {},
            outstanding_stock_cnts: {},
            outstanding_fulfilment_cnts: {},
            bo_cnts: {},

            scheduled_delivery_date_options: [
                {
                    value: null,
                    text: "All Scheduled Date",
                },
                {
                    value: "scheduled_date_yes",
                    text: "Scheduled Delivery Date",
                },
                {
                    value: "scheduled_date_no",
                    text: "NO Scheduled Delivery Date",
                },
            ],

            collection_date_options: [
                {
                    value: null,
                    text: "All Collection Date",
                },
                {
                    value: "collection_date_yes",
                    text: "Collection Date",
                },
                {
                    value: "collection_date_no",
                    text: "NO Collection Date",
                },
            ],

            successful_date_options: [
                {
                    value: null,
                    text: "All Successful Date",
                },
                {
                    value: "successful_date_yes",
                    text: "Successful Date",
                },
                {
                    value: "successful_date_no",
                    text: "NO Successful Date",
                },
            ],
        };
    },
    async created() {
        await this.getOrderMaster();
        let channels_response = await this.getChannels(this.$store.state.user_obj);
        for (let i in channels_response.channels) {
            this.channel_options.push({
                value: channels_response.channels[i].name,
                text: channels_response.channels[i].name,
            });
        }

        let clients_response = await this.getClients(this.$store.state.user_obj);
        for (let i in clients_response.clients) {
            this.client_options.push({
                value: clients_response.clients[i].id,
                text: clients_response.clients[i].full_name,
            });
        }

        // if (this.$store.state.user_obj.client_id == '77') {
        //     this.fields = collection_fields;
        // }

        this.initialized = true;
    },
    mounted() {
        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false,
        });
    },
    watch: {
        // whenever changes, this function will run
        check_all_rows: function (new_val, old_val) {
            // this.check_all_rows = !this.check_all_rows;
            console.log("check_all_rows");
            if (new_val == "all") {
                // Check all
                for (let i in this.items) {
                    this.items[i].is_checked = true;
                }
            } else {
                for (let i in this.items) {
                    this.items[i].is_checked = false;
                }
            }
            console.log(this.items);
        },
    },
    methods: {
        exportXLS_All() {

            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            this.$http({
                url: this.NODEJS_API_URL + "/gen_excel",
                method: "POST",
                data: {
                    export_type: "client_dashboard_all",
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "client_dashboard_all.xlsx");
                document.body.appendChild(link);
                link.click();

                this.loader.hide();
            });
        },

        exportXLS_Inventory() {

            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            this.$http({
                url: this.NODEJS_API_URL + "/gen_excel",
                method: "POST",
                data: {
                    export_type: "client_dashboard_inventory",
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "client_dashboard_all.xlsx");
                document.body.appendChild(link);
                link.click();

                this.loader.hide();
            });
        },

        exportOrderTrackingMaster() {
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            this.$http({
                url: this.NODEJS_API_URL + "/gen_excel",
                method: "POST",
                data: {
                    export_type: "order_tracking_master",
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                },
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "order_tracking_master.xlsx");
                document.body.appendChild(link);
                link.click();

                this.loader.hide();
            });
        },

        exportAMLo2oActive() {
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            this.$http({
                url: this.NODEJS_API_URL + "/gen_excel",
                method: "POST",
                data: {
                    export_type: "aml_o2o_inventory_active",
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                },
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "aml_o2o_inventory_active.xlsx");
                document.body.appendChild(link);
                link.click();

                this.loader.hide();
            });
        },

        exportAMLo2oStockout() {
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            this.$http({
                url: this.NODEJS_API_URL + "/gen_excel",
                method: "POST",
                data: {
                    export_type: "aml_o2o_inventory_stockout",
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                },
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "aml_o2o_inventory_stockout.xlsx");
                document.body.appendChild(link);
                link.click();

                this.loader.hide();
            });
        },

        displayDate(d) {
            if (d) {
                return moment(d).format("YYYY-MM-DD");
            } else {
                return "/";
            }
        },

        async bulkDownloadWayBill() {
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "hkt_bulk_waybill.php",
                data: {
                    items: this.items,
                },
            });
            if (response.data.url) {
                window.open(response.data.url, "_blank");
            }
            this.loader.hide();
        },

        async updateImportStatus(row_data, status) {
            if (status == "cancel") {
                return;
            }
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_approval.php",
                data: {
                    status: status,
                    order_master_ids: [row_data.id],
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });
            this.$eventHub.$emit("show_alert_message", {
                alert_message: "Update Success",
                variant: "success",
            });
            this.getOrderMaster();
        },

        async doReceiveOrder(row_data) {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_receive.php",
                data: {
                    order_master_ids: [row_data.id],
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });
            this.$eventHub.$emit("show_alert_message", {
                alert_message: "Receive Order Success",
                variant: "success",
            });
            this.getOrderMaster();
        },

        async doCommitOrder(row_data) {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_commit.php",
                data: {
                    order_master_ids: [row_data.id],
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });

            if (response.data.status === "success") {
                this.$eventHub.$emit("show_alert_message", {
                    alert_message: "Commit Order Success",
                    variant: "success",
                });
            } else {
                this.$eventHub.$emit("show_modal_message", {
                    message_content: response.data.error || "Commit Order Failed",
                    variant: "danger"
                });
            }

            this.loader_full.hide();
            this.getOrderMaster();
        },

        async doCancelOrder(row_data) {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_cancel.php",
                data: {
                    order_master_ids: [row_data.id],
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            console.log(response)

            if (response.data.status === "success") {
                this.$eventHub.$emit("show_alert_message", {
                    alert_message: "Cancel Order Success",
                    variant: "success"
                });
            } else {
                this.$eventHub.$emit("show_modal_message", {
                    message_content: response.data.error || "Cancel Order Failed",
                    variant: "danger"
                });
            }

            this.getOrderMaster();
        },

        async doHoldOrder(row_data) {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_hold.php",
                data: {
                    order_master_ids: [row_data.id],
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });
            this.$eventHub.$emit("show_alert_message", {
                alert_message: "Hold Order Success",
                variant: "success",
            });
            this.getOrderMaster();
        },

        async doFulfillOrder(row_data) {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_fulfil.php",
                data: {
                    order_master_ids: [row_data.id],
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });
            this.$eventHub.$emit("show_alert_message", {
                alert_message: "Fulfil Order Success",
                variant: "success",
            });
            this.getOrderMaster();
        },

        async updateFulfillStatus(row_data) {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_fulfill.php",
                data: {
                    order_master_ids: [row_data.id],
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });

            this.$eventHub.$emit("show_alert_message", {
                alert_message: "Update Success",
                variant: "success",
            });
            this.getOrderMaster();
        },

        async commitAll() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_commit_all.php",
                data: {
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });

            this.loader_full.hide();

            this.$eventHub.$emit("show_alert_message", {
                alert_message: "Update Success",
                variant: "success",
            });
            this.getOrderMaster();
        },

        async onSearchByStatus(status_type, status_value) {
            this.search_criteria[status_type] = status_value;
            this.getOrderMaster();
        },

        async getOrderMaster() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "client_dashboard_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.sel_table_limit,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });
            this.items = response.data.orders;
            this.total_rows = parseInt(response.data.total_rows);
            this.outstanding_order_cnts = response.data.outstanding_order_cnts;
            this.outstanding_stock_cnts = response.data.outstanding_stock_cnts;
            this.outstanding_fulfilment_cnts =
                response.data.outstanding_fulfilment_cnts;
            this.bo_cnts = response.data.bo_cnts;
            this.loader.hide();
        },

        onSearch() {
          for (const key in this.search_criteria) {
            if (typeof this.search_criteria[key] === "string") {
              this.search_criteria[key] = this.search_criteria[key].trim();
            }
          }
            this.getOrderMaster();
        },

        onPageChange(page_to_change) {
            this.table_offset = (page_to_change - 1) * this.sel_table_limit;
            this.getOrderMaster();
        },

        downloadWaybill(data) {
            let url = process.env.WAYBILL_HOST + "/waybill?";
            url += "id=" + data.tracking_number;
            window.open(url, "_blank");
        },

        async onBulkAction(bulk_action) {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            let order_master_ids = [];
            for (let i in this.items) {
                if (this.items[i].is_checked) {
                    order_master_ids.push(this.items[i].id);
                }
            }

            // call action
            let action_urls = {
                receive: "order_master_receive.php",
                commit: "order_master_commit.php",
                fulfill: "order_master_fulfil.php",
            };

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: action_urls[bulk_action],
                data: {
                    order_master_ids: order_master_ids,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });

            this.loader_full.hide();
            if (bulk_action == 'commit') {
                if (response.data.status === "success") {
                    this.$eventHub.$emit("show_alert_message", {
                        alert_message: "Commit Order Success",
                        variant: "success",
                    });
                } else {
                    this.$eventHub.$emit("show_modal_message", {
                        message_content: response.data.error || "Cancel Order Failed",
                        variant: "danger"
                    });
                }
            } else {
                this.$eventHub.$emit("show_alert_message", {
                    alert_message: "Bulk Update Success",
                    variant: "success",
                });
            }

            this.getOrderMaster();
        },

        async onBulkApprove() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });
            let order_master_ids = [];
            for (let i in this.items) {
                if (
                    this.items[i].is_checked &&
                    this.items[i].order_import_status == "pending"
                ) {
                    order_master_ids.push(this.items[i].id);
                }
            }

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_approval.php",
                data: {
                    status: status,
                    order_master_ids: order_master_ids,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });
            this.loader_full.hide();
            this.$eventHub.$emit("show_alert_message", {
                alert_message: "Update Success",
                variant: "success",
            });
            this.getOrderMaster();
        },

        async onBulkFulfill() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });
            let order_master_ids = [];
            for (let i in this.items) {
                if (
                    this.items[i].is_checked &&
                    this.items[i].order_import_status != "pending" &&
                    this.items[i].fulfilment_status == "pending"
                ) {
                    order_master_ids.push(this.items[i].id);
                }
            }

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_fulfill.php",
                data: {
                    status: status,
                    order_master_ids: order_master_ids,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });
            this.loader_full.hide();
            this.$eventHub.$emit("show_alert_message", {
                alert_message: "Update Success",
                variant: "success",
            });
            this.getOrderMaster();
        },

        async pullShopifyOrders() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            this.$http({
                url:
                    this.NODEJS_API_URL +
                    "/shopify_order_get?client_id=" +
                    this.$store.state.user_obj.client_id,
                method: "GET",
                data: null,
            }).then((response) => {
                this.loader_full.hide();
                this.getOrderMaster();
                // let json_response = JSON.parse();
                this.$eventHub.$emit("show_modal_message", {
                    message_content: `New Orders: ${response.data.cnt_new_order} \r\n Updated Orders: ${response.data.cnt_update_order}`,
                });
            });
        },

        async pullWoocomOrders() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            this.$http({
                url:
                    this.NODEJS_API_URL +
                    "/woocom_order_get?client_id=" +
                    this.$store.state.user_obj.client_id,
                method: "GET",
                data: null,
            }).then((response) => {
                this.loader_full.hide();
                this.getOrderMaster();
                // let json_response = JSON.parse();
                this.$eventHub.$emit("show_modal_message", {
                    message_content: `New Orders: ${response.data.cnt_new_order} \r\n Updated Orders: ${response.data.cnt_update_order}`,
                });
            });
        },

        async pullEccanOrders() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            this.$http({
                url:
                    this.NODEJS_API_URL +
                    "/eccang_pull_order?client_id=" +
                    this.$store.state.user_obj.client_id,
                method: "GET",
                data: null,
            }).then((response) => {
                this.loader_full.hide();
                this.getOrderMaster();
                // let json_response = JSON.parse();
                this.$eventHub.$emit("show_modal_message", {
                    message_content: `New Orders: ${response.data.cnt_new_order} \r\n Updated Orders: ${response.data.cnt_update_order}`,
                });
            });
        },

        async onUploadFile() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            let formData = new FormData();
            formData.append("excel_file", this.upload_file);
            formData.append("user_id", this.$store.state.user_obj.user_id);
            formData.append("client_id", this.$store.state.user_obj.client_id);

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_import.php",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                data: formData,
            });

            if (response) {
                this.loader_full.hide();
                if (response.data.status == "success") {
                    this.$eventHub.$emit("show_modal_message", {
                        message_content: "Upload Success",
                    });
                    if (response.data.auto_route_assigned_items) {
                        this.$eventHub.$emit("show_auto_route_review", {
                            items: response.data.auto_route_assigned_items,
                        });
                    }
                } else {
                    this.$eventHub.$emit("show_modal_message", {
                        message_content: response.data.error_msg,
                    });
                }
                this.getOrderMaster();
            }
        },

        async onUploadFileEdit() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            let formData = new FormData();
            formData.append("excel_file", this.upload_file_edit);
            formData.append("user_id", this.$store.state.user_obj.user_id);
            formData.append("client_id", this.$store.state.user_obj.client_id);

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "order_master_edit_import.php",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                data: formData,
            });

            if (response) {
                this.loader_full.hide();
                if (response.data.status == "success") {
                    this.$eventHub.$emit("show_modal_message", {
                        message_content: "Upload Success",
                    });
                } else {
                    this.$eventHub.$emit("show_modal_message", {
                        message_content: response.data.error_msg,
                    });
                }
                this.getOrderMaster();
            }
        },

        rowClass(item, type) {
            if (!item || type !== "row") return;
            if (item.is_checked) return "table-info";
        },

        async bulkDownloadWaybill() {
            let no_of_waybill = 1;
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            let courier_checked_items = {};
            let checked_items = [];
            let waybill_tracking_number = "";

            for (let i in this.items) {
                let item_tmp = this.items[i];
                console.log(item_tmp);
                if(!item_tmp.courier_short_name){
                    continue;
                }
                let courier_short_name = item_tmp.courier_short_name.toLowerCase();
                let courier_checked_item =
                    courier_checked_items[courier_short_name] || [];

                if (
                    item_tmp.is_checked &&
                    item_tmp.tracking_number &&
                    item_tmp.tracking_number != "" &&
                    courier_checked_item.indexOf(item_tmp.tracking_number) == -1
                ) {
                    waybill_tracking_number = item_tmp.tracking_number;
                    console.log(item_tmp);
                    console.log(courier_short_name);
                    courier_checked_item.push(item_tmp.tracking_number);

                    courier_checked_items[courier_short_name] = courier_checked_item;
                }
            }

            for (let [courier_short_name, courier_checked_item] of Object.entries(
                courier_checked_items
            )) {
                console.log(courier_short_name);
                console.log(courier_checked_item);

                if (!courier_checked_item || courier_checked_item.length == 0) {
                    continue;
                }

                if (courier_short_name == "gols" || courier_short_name == "whole") {
                    this.$http({
                        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
                        method: "POST",
                        data: {
                            ids: courier_checked_item,
                            print_packing: false,
                            print_waybill: true,
                            no_of_waybill: 1,
                            user_id: this.$store.state.user_obj.user_id,
                        },
                        responseType: "blob", // important
                    }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "waybill.pdf");
                        document.body.appendChild(link);
                        link.click();
                        this.loader_full.hide();
                    });
                } else if (courier_short_name == "7-11") {
                    this.$http({
                        url: this.NODEJS_API_URL + "/redemption_waybill",
                        method: "POST",
                        data: {
                            ids: courier_checked_item,
                            print_packing: false,
                            print_waybill: true,
                            no_of_waybill: no_of_waybill,
                            print_as_file: 1,
                        },
                        responseType: "blob", // important
                    }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "waybill.pdf");
                        document.body.appendChild(link);
                        link.click();
                        this.loader_full.hide();
                    });
                } else if (courier_short_name == "sf-cn") {
                    for (let i in courier_checked_item) {
                        let self = this;
                        this.pdf_to_print =
                            "https://tracking.gols.com.hk/waybill_file/" +
                            courier_short_name +
                            "/" +
                            courier_checked_item[i] +
                            ".pdf";

                        fetch(self.pdf_to_print).then(function (t) {
                            return t.blob().then((b) => {
                                var a = document.createElement("a");
                                a.href = URL.createObjectURL(b);
                                a.setAttribute("download", self.pdf_to_print.split("/").pop());
                                a.click();
                            });
                        });

                        let response = await this.$http({
                            method: "POST",
                            baseURL: `${this.API_HOST}`,
                            url: "print_waybill_log.php",
                            data: {
                                tracking_number: courier_checked_item[i],
                                client_id: this.$store.state.user_obj.client_id,
                                user_id: this.$store.state.user_obj.user_id,
                            },
                        });
                    }
                }
            }
            this.loader_full.hide();
        },
    },
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.span-status {
    display: none;
}

.container-status:hover .span-status {
    display: inline;
}

.row-status_cnt {
    display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/ClientDashboard.vue